import { bluePalette, goodPalette, extendedGoodPalette, badPalette, reversedGoodPalette, reversedBadPalette, strongSupport, weakSupport, weakOppose, strongOppose, neutral } from "../../../../src/utils/pulsePalette.js";
import crowd from "../../../../src/images/icons/crowd.svg";
import direction from "../../../../src/images/icons/direction.svg";
import mayor from "../../../../src/images/icons/mayor.svg";
import updown from "../../../../src/images/icons/updown.svg";
import { H1, H3 } from "../../../../src/components/layout/headings";
import { SupportOpposeLineChart, InteractiveFavorabilityChart, LurieFavorability, BOSFavorability } from "../../../../src/components/pulse/lineChart.js";
import CrossTabChart from "../../../../src/components/pulse/CrossTabChart";
import { Collapsible } from "../../../../src/components/layout/collapsible";
import * as React from 'react';
export default {
  bluePalette,
  goodPalette,
  extendedGoodPalette,
  badPalette,
  reversedGoodPalette,
  reversedBadPalette,
  strongSupport,
  weakSupport,
  weakOppose,
  strongOppose,
  neutral,
  crowd,
  direction,
  mayor,
  updown,
  H1,
  H3,
  SupportOpposeLineChart,
  InteractiveFavorabilityChart,
  LurieFavorability,
  BOSFavorability,
  CrossTabChart,
  Collapsible,
  React
};